import { connect } from 'react-redux';
import { FILTER_TYPES } from '../../../constants';
import FilterReviews from './FilterReviews';

const mapStateToProps = (state) => {
    const showBreakdown = state.breakdown && state.displayBreakdown;
    const showLocation = state.displayLocation;
    const displayRelevant = state.displayRelevant;
    const filterValues = showBreakdown
        ? [FILTER_TYPES.recent]
        : [FILTER_TYPES.recent, FILTER_TYPES.negative, FILTER_TYPES.positive];

    if (displayRelevant) {
        filterValues.push(FILTER_TYPES.relevant);
    }

    if (showLocation) {
        filterValues.push(FILTER_TYPES.local_reviews);
    }

    return {
        filterValues,
        type: state.type,
    };
};

export default connect(mapStateToProps)(FilterReviews);
